import { ClockIcon } from '@heroicons/react/24/outline'

const ComingSoon = () => {
	return (
		<div className='max-w-lg mx-auto'>
			<div className='rounded-3xl border-2 border-sage-200 bg-sage-50/50 p-8 text-center'>
				<div className='flex justify-center mb-4'>
					<div className='w-12 h-12 rounded-full bg-sage-100 flex items-center justify-center'>
						<ClockIcon className='w-6 h-6 text-sage-500' />
					</div>
				</div>

				<div className='space-y-6'>
					<div>
						<h2 className='font-display text-xl font-semibold text-sage-800 mb-2'>
							Biljettsläpp snart
						</h2>
						<p className='text-sage-600 text-sm leading-relaxed'>
							Biljetter till Harmoni Expo den 28–29 mars släpps inom kort.
						</p>
						<p className='text-sage-600 text-sm leading-relaxed mt-1'>
							I år firar vi 30 år och mer information om jubileet presenteras snart.
						</p>
					</div>

					<div className='border-t border-sage-200 pt-6'>
						<h2 className='font-display text-xl font-semibold text-sage-800 mb-2'>
							Tickets coming soon
						</h2>
						<p className='text-sage-600 text-sm leading-relaxed'>
							Tickets for Harmoni Expo – Spring Fair, March 28–29 will be released soon.
						</p>
						<p className='text-sage-600 text-sm leading-relaxed mt-1'>
							This year marks our 30th anniversary, with more details to be shared soon.
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ComingSoon
